export default "__VITE_PUBLIC_ASSET__b986abcb__"